export default "__VITE_ASSET__CSAo1sEj__"